import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {branches_settings} from './branches_settings';

@Injectable()
export class BranchesSettingsService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('branches_settings?' + params.toString()).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('branches_settings/' + _id).map((response: Response) => response.json());
  }

  getAllBranches() {
    return this.http.get('branches_settings/all').map((response: Response) => response.json());
  }

  getUserBranches() {
    return this.http.get('branches/userbranches').map((response: Response) => response.json());
  }

  getAvailableBranches() {
    return this.http.get('settings/branches').map((response: Response) => response.json());
  }

  getTrashedById(_id: string) {
    return this.http.get('branches_settings/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('branches_settings/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(branch: branches_settings) {
    return this.http.post('branches_settings', branch).map((response: Response) => response.json());
  }

  update(branch: branches_settings) {
    return this.http.put('branches_settings/' + branch.id, branch).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('branches_settings/' + _id).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/branches_settings/branches_settings.service.ts